// Libs
import React from 'react';
import { Box } from '@mui/material';

// Components
import Spinner from '../../../components/Spinner';
import Table from '../../../components/Table';
import EmptyKitsScreen from '../../../components/Kits/EmptyKitsScreen/EmptyKitsScreen';
import TableRow from '../../../components/Kits/TableRow/TableRow';
import TotalQtyLabel from '../../../components/Labels/TotalQtyLabel';
import KitsBar from '../../../components/Kits/KitsBar/KitsBar';

// Hooks
import useKits from '../hooks/useKits';
import useKitActions from '../hooks/useKitActions';
import useUI from '../../../hooks/useUI';
import useKitsCellsReducers from '../hooks/useKitsCellsReducers';

import { kitsTableColumns } from '../../../constants/kits';
import useUser from '../../../hooks/useUser';
import KitAdaptiveCard from '../../../components/Kits/KitAdaptiveCard/KitAdaptiveCard';
import Error from '../../../components/Error';

// Styles
import { useTableStyles } from './KitsStyles';

const Kits = () => {
  const { isKiteUser } = useUser();
  const { isTabletMode } = useUI();
  const { isLoading, kits, filteredKits, apiError } = useKits();
  const { onDeleteAllClick } = useKitActions();
  const { classes: tableClasses } = useTableStyles({ isKiteUser });

  const hasKits = kits.data !== null && kits?.data?.length > 0;

  const renderContent = () => {
    if (isLoading) {
      return <Spinner />;
    }

    if (apiError) {
      return <Error message={apiError} />;
    }

    if (!hasKits) {
      return <EmptyKitsScreen />;
    }

    return (
      <>
        <TotalQtyLabel qty={filteredKits.length} type={'kit'} />
        {isTabletMode ? (
          <Box mt={1}>
            {filteredKits.map((kit) => (
              <KitAdaptiveCard key={kit.id} kit={kit} />
            ))}
          </Box>
        ) : (
          filteredKits.length > 0 && (
            <Table
              data={filteredKits}
              useCellsReducers={useKitsCellsReducers}
              columns={kitsTableColumns}
              styles={tableClasses}
              TableRow={TableRow}
            />
          )
        )}
      </>
    );
  };

  return (
    <>
      <KitsBar withDeleteAll={hasKits} onDeleteAll={onDeleteAllClick} />
      {renderContent()}
    </>
  );
};

export default Kits;
